import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import "./login.css";

function Login() {

  const navigate = useNavigate();

  const [isRegister, setIsRegister] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    department: "",
    designation: "",
    position: "",
    email: "",
    password: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // ✅ LOGIN FIXED
  const handleLogin = async (e) => {
  e.preventDefault();


  try {
    const res = await API.post("/auth/login", {
      email: formData.email,
      password: formData.password
    });

    const data = res.data; // ✅ FIX (axios me ye hota hai)

    console.log(data);

    // ✅ CLEAN STORAGE (duplicate hata diya)
    localStorage.setItem("token", data.token);
    localStorage.setItem("role", data.user.role);
    localStorage.setItem("userId", data.user.id);
    localStorage.setItem("name", data.user.name);
    localStorage.setItem("role", data.user.role.toLowerCase());

    alert("Login Successful");

    const role = data.user.role.toLowerCase();

    if (role === "boss") navigate("/boss");
    else if (role === "sales manager") navigate("/manager");
    else if (role === "sales executive") navigate("/salesexec");
    else if (role === "telesales") navigate("/telesales");
    else if (role === "it manager") navigate("/itmanager");
    else navigate("/");

  } catch (error) {
    console.log(error.response?.data);
    alert(error.response?.data?.message || "Login Failed");
  }
};

  // ✅ REGISTER FIXED
  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      await API.post("/auth/register", formData); // ✅ FIXED

      alert("Registration Successful");
      setIsRegister(false);

    } catch (error) {
      console.log(error.response?.data);
      alert(error.response?.data?.message || "Registration Failed");
    }
  };

  return (

    <div className="auth-container">
      <div className="auth-card">
        
        <h2 className="auth-title">DigiMarq CRM</h2>
        <p className="auth-subtitle">Sign in to your account</p>

        <form className="auth-form" onSubmit={handleLogin}>
          
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            className="auth-input"
            onChange={handleChange}
            required
          />

          <div className="auth-password-box">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              className="auth-input"
              onChange={handleChange}
              required
            />

            <span
              className="auth-toggle-pass"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </span>
          </div>

          <button type="submit" className="auth-btn">
            Sign In
          </button>

        </form>

        <div className="auth-footer">
          Don't have an account? <span>Contact Admin</span>
        </div>

      </div>
    </div>

  );
}

export default Login;